import React, {Component} from 'react';
import {Link} from "react-router-dom";
import {withTranslation} from 'react-i18next';

import axios from '../../axios-defaults';
import Aux from "../../hoc/Auxiliary";

import TableContainer from './Table/TableContainer'; // TABLE DOCS : https://react-table.tanstack.com/docs/
import Spinner from "../UI/Spinner";
import Card from "../Cards/Card";
import Pagination from "../UI/Pagination";
import SearchForm from "../../components/UI/SearchForm/SearchForm";
import SelectWrapper from "../Utils/Input/SelectWrapper";
import DisplaySwitcher from "../UI/Toolbar/DisplaySwitcher";
import DateFormated from "../Utils/Date/Date";
import Sorter from "../UI/Toolbar/Sorter";
import Currency from "../Utils/Number/Currency";
import PaymentPopup from "../UI/PaymentPopup";
import Alert from "../UI/Alerts/Alert";
import DeliveriesTab from "./Account/OrdersHistory/OrdersHistory";

import UserContext from '../../context/user-context';
import {userHaveSpecificPermission} from "../../components/Utils/UserHelper";
import {fireGTMDownloadFileEvent} from "../Utils/GTM/GTMHelper";

class AccountsList extends Component {
    static contextType = UserContext;

    constructor(props) {
        super(props);

        this.state = {
            allSubAccounts: [],
            currentSubAccounts: [],
            pagination: {
                currentPage: 1,
                itemsPerPage: 6,
                totalPages: null
            },
            filters: {
                favorites: false,
                recentlyViewed: false,
                productType: '',
                accountType: ''
            },
            hasSearched: false,
            favorites: [],
            recentlyViewed: [],
            accountTypes: [],
            productTypes: [],
            displayMode: 'card',
            lang: this.props.i18n.language,
            loading: true,
            sortField: 'subAccountCode',
            sortDirection: 'DESC',
            sortTableField: 'subAccountCode',
            sortTableDirection: 'DESC',
            noSubAccount: false
        }

        this.sorter = null;
        this.setSorterRef = element => this.sorter = element;
    }

    componentDidMount() {
        this.setDisplayMode(null);
        this.getSubAccounts();
        this.getFavorites();
        this.getRecentlyViewed();
    }

    setDisplayMode = (mode = null) => {
        if (!mode) mode = this.getStoredDisplayMode();
        mode = ['card', 'list'].includes(mode) ? mode : 'card';
        localStorage.setItem('displayMode', mode);
        this.setState({displayMode: mode});
    }

    getStoredDisplayMode = () => {
        let mode = localStorage.getItem('displayMode');
        if (!mode) mode = this.state.displayMode;
        return mode;
    }

    setAccountTypes = () => {
        // Use current data to show only available product types
        let types = [];
        this.state.allSubAccounts.forEach(element => {
            types.push(element.subAccountType);
        });

        // filter duplicates
        return this.setState({
            accountTypes: [...new Map(types.map(item => [item.code, item])).values()]
        });
    }

    setProductTypes = () => {
        // Use current data to show only available account types
        let promises = [];
        this.state.allSubAccounts.map(element => {
            let endpoint = `/subAccounts/tanks?subAccountCode=${element.subAccountCode}`;
            promises.push(axios.get(endpoint));
        });

        Promise.all(promises).then(responses => {
            responses.forEach(response => {
                if (response.data.succeeded) {
                    response.data.data.forEach(item => {
                        this.setState(prevState => ({
                            productTypes: [
                                ...prevState.productTypes,
                                {
                                    'code': item.productCode,
                                    'name': item.productName
                                }
                            ]
                        }));
                    });
                }
            })
        });
    }

    getFavorites = () => {
        this.setState({loading: true});
        axios.get(`/subaccounts/favorites`)
            .then(response => {
                if (response.data.succeeded) {
                    this.setState({favorites: response.data.data.favorite_ids});
                }
                this.setState({loading: false});
            }).catch(error => {
            console.log('[AccountsList.js] : Favorites ajax error in getFavorites()', error.message);
            this.setState({loading: false});
        });
    }

    getRecentlyViewed = () => {
        this.setState({loading: true});
        axios.get(`/subaccounts/recently_viewed`)
            .then(response => {
                if (response.data.succeeded) {
                    this.setState({recentlyViewed: response.data.data.recentlyviewed_ids});
                }
                this.setState({loading: false});
            }).catch(error => {
            console.log('[AccountsList.js] : Recently Viewed ajax error in getRecentlyViewed()', error.message);
            this.setState({loading: false});
        });
    }

    getSubAccounts = async () => {
        this.setState({loading: true});
        await axios.get(`/accounts/subaccounts`)
            .then(response => {
                if (response.data.succeeded) {
                    let subAccountDisplayed = [];
                    if (this.props.isSummary) {
                        subAccountDisplayed = this.mapSubAccount(response.data.data)
                    } else {
                        subAccountDisplayed = response.data.data
                    }
                    if (subAccountDisplayed.length === 0) {
                        this.setState({noSubAccount: true})
                    }

                    if (subAccountDisplayed.find((elem) => elem.subAccountDisplayMode.code === "A") !== undefined) {
                        subAccountDisplayed = subAccountDisplayed.sort(function (a, b) {
                            if (a.subAccountDisplayMode.code.toLowerCase() < b.subAccountDisplayMode.code.toLowerCase()) return -1;
                            if (a.subAccountDisplayMode.code.toLowerCase() > b.subAccountDisplayMode.code.toLowerCase()) return 1;
                            return 0;
                        });
                    }

                    this.setState({
                        allSubAccounts: subAccountDisplayed,
                        currentSubAccounts: subAccountDisplayed
                    }, () => {
                        this.setAccountTypes();
                        // this.setProductTypes(); // disabled for now
                    });
                    //console.log('[AccountsList.js] getSubAccounts() Data list',response.data.data);
                }
                this.setState({loading: false});
            }).catch(error => {
                //console.log('[AccountsList.js] : Subaccounts ajax error in getSubAccounts()', error.message);
                this.setState({loading: false});
            });
    }

    mapSubAccount = (data) => {
        return data.filter(item => {
            return this.state.favorites.includes(item.subAccountCode) || item.isDisabled === false
        })
    }

    onPageChanged = data => {
        const {currentPage, totalPages} = data;
        this.setState({
            pagination: {
                ...this.state.pagination,
                currentPage: currentPage,
                totalPages: totalPages,
            }
        });
    }

    addFavorites = (id = null) => {
        if (!id) {
            return false;
        }
        const {favorites} = this.state;

        this.setState({loading: true});
        axios.post(`/subaccounts/favorites`, {account_id: id})
            .then(response => {
                if (response.data.succeeded) {
                    this.setState({
                        favorites: [...favorites, id]
                    });
                }
                this.setState({loading: false});
            }).catch(error => {
            this.setState({loading: false});
            console.log('[AccountsList.js] : Favorites ajax error in addRemoveFavoriteHandler()', error.message);
        });
    }

    removeFavorites = (id = null) => {
        if (!id) {
            return false;
        }

        this.setState({loading: true});
        axios.delete(`/subaccounts/favorites/${id}`)
            .then(response => {
                if (response.data.succeeded) {
                    this.setState(previousState => {
                        return {favorites: previousState.favorites.filter(item => item !== id)};
                    });
                }
                this.setState({loading: false});
            })
            .catch(error => {
                this.setState({loading: false});
                console.log('[AccountsList.js] : Favorites ajax error in addRemoveFavoriteHandler()', error.message);
            });
    }

    addRemoveFavoriteHandler = (id = null) => {
        if (!id) return false;

        let isFavorite = this.state.favorites.includes(id);

        if (isFavorite) {
            this.removeFavorites(id);
        } else {
            this.addFavorites(id);
        }
    }

    onSearchDataUpdate = (searchData) => {
        this.setState({'hasSearched': true});
        if (Array.isArray(searchData)) {
            return this.setState({currentSubAccounts: searchData});
        } else {
            return null;
        }
    }

    resetFiltersHandler = () => {
        this.setState({
            filters: {
                favorites: false,
                recentlyViewed: false
            }
        });
    }

    clearSearchHandler = () => {
        const searchFields = document.querySelectorAll('input#search');
        for (let i = 0; i < searchFields.length; ++i) {
            searchFields[i].value = '';
        }
    }

    onFilterChange = (value, filter) => {
        if (!filter) {
            return null;
        }

        // this.clearSearchHandler();
        this.setState({
            filters: {
                ...this.state.filters,
                [filter]: value
            }
        });
    }

    mapFilteredData = () => {
        const {filters, currentSubAccounts} = this.state;
        let filterDatas = [];

        filterDatas = currentSubAccounts.filter(item => {
            // loop through active filters and check if the current item match them
            let isMatching = true;

            Object.entries(filters).forEach(entry => {
                const [key, value] = entry;
                if (value) {
                    switch (key) {
                        case 'favorites':
                            isMatching = this.state.favorites.includes(item.subAccountCode) && isMatching;
                            break;
                        case 'recentlyViewed':
                            isMatching = this.state.recentlyViewed.includes(item.subAccountCode) && isMatching;
                            break;
                        case 'accountType':
                            isMatching = item.subAccountType.code === filters.accountType && isMatching;
                            break;
                        default:
                            isMatching = true;
                    }
                }
            })
            // return result of our match algorithm
            return isMatching;
        })

        return filterDatas
    }

    sortItems = () => {
        if (this.sorter) {
            this.sorter.sortItems();
        } else if (this.state.currentSubAccounts !== null) {
            this.state.currentSubAccounts.sort(this.defaultSort);
        }
        let adjustmentAccount = this.state.currentSubAccounts.find(item => item.subAccountDisplayMode.code === "A");
        if (adjustmentAccount !== undefined) {
            if (adjustmentAccount.totalBalance && adjustmentAccount.totalBalance.value !== 0.00)
                this.state.currentSubAccounts = [adjustmentAccount, ...this.state.currentSubAccounts.filter(item => item.subAccountDisplayMode.code !== "A")];
            else this.state.currentSubAccounts = [...this.state.currentSubAccounts.filter(item => item.subAccountDisplayMode.code !== "A"), adjustmentAccount];
        }

    }

    sortByTransactionDate = (a, b) => {
        if (a.lastTransactionDate !== null && b.lastTransactionDate !== null) {
            return b.lastTransactionDate.localeCompare(a.lastTransactionDate);
        }
        if (a.lastTransactionDate !== null && b.lastTransactionDate === null) {
            return -1;
        }
        if (a.lastTransactionDate === null && b.lastTransactionDate !== null) {
            return 1;
        }

        return 0;
    }

    defaultSort = (a, b) => {
        const aIsFavorites = this.state.favorites.includes(a.subAccountCode);
        const bIsFavorites = this.state.favorites.includes(b.subAccountCode);
        if ((aIsFavorites && bIsFavorites) || (!aIsFavorites && !bIsFavorites)) {
            return this.sortByTransactionDate(a, b);
        }
        if (aIsFavorites && !bIsFavorites) {
            return -1;
        }
        if (!aIsFavorites && bIsFavorites) {
            return 1;
        }

        return 0;
    }

    handleSort = (sortBy) => {
        if (sortBy.length > 0) {
            const isDESC = this.state.sortDirection === 'DESC'
            if (this.state.sortField !== sortBy[0].id || isDESC !== sortBy[0].desc) {
                this.setState({sortField: sortBy[0].id, sortDirection: sortBy[0].desc ? 'DESC' : 'ASC'});
            }
        }
    }

    storeSortedItems = (items) => {
        this.setState({currentSubAccounts: items});
    }
    setSorterCallback = (columnId, direction) => {
        this.setState({sortField: columnId, sortDirection: direction});
    }

    render() {
        const user = this.context.user;

        if (this.props.isSummary) {
            this.sortItems();
        }
        const {t} = this.props;
        const {
            allSubAccounts,
            pagination,
            loading,
            favorites,
            recentlyViewed,
            displayMode,
            hasSearched,
            noSubAccount
        } = this.state;
        const totalItems = (allSubAccounts) ? allSubAccounts.length : 0;
        let subAccountRender = [];
        let subAccountRenderPaged = false;

        subAccountRender = this.mapFilteredData();
        if (displayMode === 'card' || this.props.isSummary) {
            const pageLimit = pagination.itemsPerPage;
            const currentPage = pagination.currentPage;
            const offset = (currentPage - 1) * pageLimit;
            subAccountRenderPaged = subAccountRender.slice(offset, offset + pageLimit);
        }
        const totalCurrentItems = (subAccountRender) ? subAccountRender.length : 0;
        let totalFavorites = subAccountRender.filter(item => favorites.includes(item.subAccountCode))
        let totalRecentlyViewed = subAccountRender.filter(item => recentlyViewed.includes(item.subAccountCode))
        let accounts = <Spinner/>

        let title = this.props.t('dashboard.subaccounts.title');
        let titleClass = 'headline--section';


        if (!this.props.isSummary) {
            let filtersEnabled = false;
            Object.values(this.state.filters).forEach(value => {
                filtersEnabled = ((value !== '' && value !== false) && !filtersEnabled) || filtersEnabled;
            });

            if (totalItems > 1 || totalCurrentItems > 1) {
                if (filtersEnabled || hasSearched) title = totalCurrentItems + ' ' + this.props.t('misc.accounts_lowercase_criteria');
                else title = totalItems + ' ' + this.props.t('misc.accounts_lowercase');
            } else {
                if (filtersEnabled || hasSearched) title = totalCurrentItems + ' ' + this.props.t('misc.account_lowercase_criteria');
                else title = totalItems + ' ' + this.props.t('misc.account_lowercase');
            }
            titleClass = 'headline--block';
        }

        if (subAccountRenderPaged && allSubAccounts) {

            accounts = (
                subAccountRenderPaged.map((account, index) => {
                    let accountTypeAccessor = 'descriptionEn';
                    if (this.props.i18n.language === 'fr') accountTypeAccessor = 'descriptionFr';

                    let type = account.subAccountDisplayMode.code;

                    let id = account.subAccountCode;
                    let additionalClasses = [`card--${account.subAccountType[accountTypeAccessor].replace(/[^a-zA-Z0-9]/g, '').toLowerCase()}`]

                    let dataToTest;

                    let tooltipText = false;
                    if (userHaveSpecificPermission(user, 'financial_data')) {
                        if (type === 'K' || type === 'H') {
                            dataToTest = account.lastStatementBalance.value;
                        } else {
                            dataToTest = account.totalBalance.value;
                        }

                        if (dataToTest > account.maximumOnlinePaymentAllowed) {
                            tooltipText = <div>{t("popup.overmaximumpaimentlimit")}</div>;
                        }
                        if (dataToTest <= account.minimumOnlinePaymentAllowed) {
                            tooltipText = <div>{t("popup.underminimumpaimentlimit")}</div>;
                        }
                    }

                    return (
                        <Card
                            cardTitle={(account.subAccountName) ? account.subAccountName : account.subAccountType[accountTypeAccessor]}
                            cardLink={'/accounts/' + account.subAccountCode}
                            data={account}
                            key={index}
                            showFavoriteButton={type !== "A"}
                            isFavorite={favorites.includes(account.subAccountCode)}
                            addRemoveFavorite={this.addRemoveFavoriteHandler}
                            additionalClasses={additionalClasses}
                            id={id}
                        >
                            <div className="messages">
                                {   // For everything unless Cardlock or Credit cards
                                    (type !== "H" && type !== "K") && account.isDeliveryInProcess &&
                                    <Alert type="success" item={{
                                        type: 'success',
                                        link: '/accounts/' + account.subAccountCode + '#deliveries',
                                        additionalClasses: 'message--condensed message--delivery',
                                        customIcon: 'fas fa-shipping-fast',
                                        text: t("orders.current_order")
                                    }}/>
                                }
                            </div>
                            <div className='card__infos'>
                                <div className='card__name'><strong>
                                    {(() => {
                                        if (type === 'K' || type === 'H') {
                                            return (
                                                <span>
                                                {t("account.cards.representative_label")}<br/>
                                                    {account.representative}
                                            </span>
                                            )
                                        } else {
                                            return (
                                                <Aux>
                                                    {account.address.addressLine1} <br/>
                                                    {account.address.addressLine2 ? <>{account.address.addressLine2}<br/></> : ''}
                                                    {account.address.city} <br/>
                                                    {account.address.postalCode}{account.address.postalCode && account.address.stateOrProvinceCode ? ', ' : ''} {account.address.stateOrProvinceCode}
                                                </Aux>
                                            )
                                        }
                                    })()}
                                </strong></div>

                                <div className='card__id'>
                                    {account.subAccountCode ? '#' + account.subAccountCode : ''}
                                </div>
                                {(() => {
                                    if (account.numberOfCards) {
                                        return (
                                            <div className='card__nbcards'>
                                                <span>{t("card.numberofcards")} : </span>
                                                <strong>{account.numberOfCards}</strong>
                                            </div>
                                        )
                                    } else {
                                        return ''
                                    }
                                })()}
                            </div>

                            {(() => {
                                if (userHaveSpecificPermission(user, 'financial_data')) {
                                    return (
                                        <div className='card__current'>
                                            <div className='row'>
                                                {(() => {
                                                    if ((type === 'K' || type === 'H') && account.lastStatementBalance) {
                                                        let canDoPayment = (account.lastStatementBalance.value != ''
                                                            && account.isOnlinePaymentAllowed &&
                                                            (account.lastStatementBalance.value > account.minimumOnlinePaymentCreditCard
                                                                ||  account.lastStatementBalance.value > account.minimumOnlinePaymentEFT)
                                                            && (account.lastStatementBalance.value < account.maximumOnlinePaymentCreditCard
                                                                ||  account.lastStatementBalance.value < account.maximumOnlinePaymentEFT)
                                                        );
                                                        return (
                                                            <div className='col-6'>
                                                                <div>{t("card.amounttopay")}</div>
                                                                <div className='price--small'>
                                                                    <Currency
                                                                        value={account.lastStatementBalance.value}/>
                                                                </div>
                                                                {
                                                                    (canDoPayment) ?
                                                                        <div style={{marginTop: '12px'}}>
                                                                            <Link
                                                                                className='btn btn--outline btn--outline--black btn--payment'
                                                                                to={{pathname:'/payment',
                                                                                    state: {by: "subaccount", selection : [id]}
                                                                                }}
                                                                            >
                                                                                <i className="fas fa-file-invoice-dollar"></i>&nbsp;&nbsp;{t('payment.button')}
                                                                            </Link>
                                                                        </div>
                                                                        : ''
                                                                }
                                                            </div>
                                                        )
                                                    } else if (type === 'L' && account.totalBalance) {
                                                        let canDoPayment = (account.totalBalance.value !== '' &&
                                                            account.isOnlinePaymentAllowed &&
                                                            (account.totalBalance.value > account.minimumOnlinePaymentCreditCard
                                                                ||  account.totalBalance.value > account.minimumOnlinePaymentEFT)
                                                            && (account.totalBalance.value < account.maximumOnlinePaymentCreditCard
                                                                ||  account.totalBalance.value < account.maximumOnlinePaymentEFT));

                                                        return (
                                                            <Aux>
                                                                <div className='col-6'>
                                                                    <div>{t("card.amounttotal")}</div>
                                                                    <div className='price--small'>
                                                                        <Currency value={account.totalBalance.value}/>
                                                                    </div>
                                                                </div>

                                                                <div className='col-6'>
                                                                    {
                                                                        (canDoPayment) ?
                                                                            <div style={{marginTop: '12px'}}>
                                                                                <Link
                                                                                    className='btn btn--outline btn--outline--black btn--payment'
                                                                                    to={{pathname:'/payment',
                                                                                        state: {by: "subaccount", selection : [id]}
                                                                                    }}
                                                                                >
                                                                                    <i className="fas fa-file-invoice-dollar"></i>&nbsp;&nbsp;{t('payment.button')}
                                                                                </Link>
                                                                            </div> : ''
                                                                    }
                                                                </div>
                                                            </Aux>
                                                        )
                                                    } else if (type === 'A') {
                                                        let canDoPayment = (account.totalBalance.value !== '' &&
                                                            account.isOnlinePaymentAllowed &&
                                                            (account.totalBalance.value > account.minimumOnlinePaymentCreditCard
                                                                ||  account.totalBalance.value > account.minimumOnlinePaymentEFT)
                                                            && (account.totalBalance.value < account.maximumOnlinePaymentCreditCard
                                                                ||  account.totalBalance.value < account.maximumOnlinePaymentEFT));

                                                        return (
                                                            <Aux>
                                                                <div className='col-6'>
                                                                    <div>{t("card.amounttotalshort")}</div>
                                                                    <div className='price--small'>
                                                                        <Currency value={account.totalBalance.value}/>
                                                                    </div>
                                                                </div>
                                                                <div className='col-6'>
                                                                    {(canDoPayment) ?
                                                                        <div style={{marginTop: '12px'}}>
                                                                            <Link
                                                                                className='btn btn--outline btn--outline--black btn--payment'
                                                                                to={{pathname:'/payment',
                                                                                    state: {by: "subaccount", selection : [id] }
                                                                                }}
                                                                            >
                                                                                <i className="fas fa-file-invoice-dollar"></i>&nbsp;&nbsp;{t('payment.button')}
                                                                            </Link>
                                                                        </div> : ''}
                                                                </div>
                                                            </Aux>

                                                        )
                                                    } else if (account.nextPreauthorizePaymentAmount) {
                                                        return (
                                                            <div className='col-6'>
                                                                <div>{t("card.nextprel")}</div>
                                                                <div className='price--small'>
                                                                    <Currency
                                                                        value={account.nextPreauthorizePaymentAmount.value}/>
                                                                </div>
                                                            </div>
                                                        )
                                                    }
                                                })()}
                                                {(() => {
                                                    if (type === 'K' || type === 'H') {
                                                        return (
                                                            <div className='col-6 a-right'>
                                                                <div>{t("card.echeance")}</div>
                                                                <div>
                                                                    <strong>
                                                                        {account.lastStatementDueDate ? <DateFormated
                                                                            date={account.lastStatementDueDate}/> : ''}
                                                                    </strong>
                                                                </div>
                                                            </div>
                                                        )
                                                    }
                                                })()}
                                            </div>
                                        </div>
                                    )
                                } else {
                                    return ''
                                }
                            })()}

                            {(() => {
                                if (userHaveSpecificPermission(user, 'financial_data')) {
                                    return (
                                        <div
                                            className={`card__last ${type === 'S' ? 'hide' : ''} ${type === 'A' ? 'card__last--rm-line' : ''}`}>
                                            {(() => {
                                                if (type === 'K') {
                                                    return (
                                                        <div>
                                                            <div>
                                                                {t("card.fromlastreading")}
                                                            </div>
                                                            <div className='price--smaller'>
                                                                {account.sinceLastStatementQuantity.formattedUnitValue}
                                                            </div>
                                                        </div>
                                                    )
                                                } else if (type === 'H') {
                                                    return (
                                                        <div>
                                                            <div>
                                                                {t("card.lastrel")}
                                                            </div>
                                                            <div className='price--smaller'>
                                                                <Currency
                                                                    value={account.sinceLastStatementBalance.value}/>
                                                            </div>
                                                        </div>
                                                    )
                                                }
                                            })()}
                                            {(() => {
                                                if (type === 'K' || type === 'H' || type === 'A') {
                                                    return (
                                                        <div>
                                                            <div>
                                                                {t("card.lasttrans")}
                                                            </div>
                                                            <strong className=''>
                                                                {account.lastTransactionDate ?
                                                                    <DateFormated
                                                                        date={account.lastTransactionDate}/> : ''}
                                                            </strong>
                                                        </div>
                                                    )
                                                } else if (type === 'L' && account.totalBalance) {
                                                    return (
                                                        <div>
                                                            <div>
                                                                {t("card.total")}
                                                            </div>
                                                            <strong className=''>
                                                                <Currency value={account.totalBalance.value}/>
                                                            </strong>
                                                        </div>
                                                    )
                                                }
                                            })()}
                                        </div>
                                    )
                                } else {
                                    return ''
                                }
                            })()}

                            {(() => {
                                if (userHaveSpecificPermission(user, 'financial_data')) {
                                    return (
                                        <div className='card__action'>
                                            {
                                                (account.lastStatementDocumentPath)
                                                    ?
                                                    <a href={`/rest/v1/communications/download?filename=${encodeURI(account.lastStatementDocumentPath)}`}
                                                       target="_blank"
													   onClick={()=>fireGTMDownloadFileEvent('releve', 'PDF')}
                                                       className='link link--red link--upper link--fs-14 link--accent'><strong>{t("card.seelast")}</strong></a>
                                                    : ''
                                            }
                                        </div>
                                    )
                                } else {
                                    return ''
                                }
                            })()}
                        </Card>
                    )
                }));
        }

        let subAccounthtml = '';

        if (loading) {
            subAccounthtml = (
                <section className='section section--youraccount section--padding--40'>
                    <h2 className={titleClass + ' headline--margin--15'}>
                        <Spinner/>
                    </h2>
                </section>
            )
        }

        if (!loading && totalItems === 0 && allSubAccounts && noSubAccount) {
            subAccounthtml = (
                <section className='section section--youraccount section--padding--40'>
                    <h2 className={titleClass + ' headline--margin--15'}>
                        {title}
                    </h2>
                    <p><strong>{this.props.t('dashboard.subaccounts.noresults')}</strong></p>
                </section>
            );
        } else if (!loading && totalItems > 0) {
            const columns = [
                {
                    Header: this.props.t('dashboard.subaccounts.table.header.name'),
                    accessor: 'subAccountName',
                    Cell: (props) => {
                        return props.value ? (
                            <strong><Link to={'/accounts/' + props.row.original.subAccountCode}
                                          className="link link--accent link--red link--underline">{props.value}</Link></strong>
                        ) : '';
                    },
                },
                {
                    Header: this.props.t('dashboard.subaccounts.table.header.code'),
                    accessor: 'subAccountCode',
                    Cell: (props) => {
                        return props.value ? props.value : '';
                    }
                },
                {
                    Header: this.props.t('dashboard.subaccounts.table.header.account_type'),
                    id: 'subAccountType',
                    accessor: 'subAccountType',
                    sortType: (
                        (rowA, rowB, columnId) => {
                            const a = rowA.values[columnId].code;
                            const b = rowB.values[columnId].code;
                            return a > b ? 1 : -1;
                        }
                    ),
                    Cell: (props) => {
                        let descriptionAccessor = 'descriptionEn';
                        if (this.props.i18n.language === 'fr') descriptionAccessor = 'descriptionFr';
                        return props.value[descriptionAccessor] ? props.value[descriptionAccessor] : '';
                    },
                },
                {
                    Header: this.props.t('dashboard.subaccounts.table.header.balance'),
                    accessor: 'totalBalance',
                    sortType: (
                        (rowA, rowB, columnId) => {
                            const a = parseFloat(rowA.values[columnId].value.toFixed(2));
                            const b = parseFloat(rowB.values[columnId].value.toFixed(2));
                            return a > b ? 1 : -1;
                        }
                    ),
                    Cell: (props) => {
                        const type = props.row.values.subAccountType.code;

                        let value = null;
                        if ((type === 'K' || type === 'H') && props.row.original.lastStatementBalance) {
                            value = props.row.original.lastStatementBalance.value;
                        } else if (type === 'L' && props.row.original.totalBalance) {
                            value = props.row.original.totalBalance.value;
                        } else if (type === 'A' && props.row.original.totalBalance) {
                            value = props.row.original.totalBalance.value;
                        } else if (props.row.original.nextPreauthorizePaymentAmount) {
                            value = props.row.original.nextPreauthorizePaymentAmount.value;
                        }

                        return value !== null ? <strong><Currency value={value}/></strong> : '';
                    }
                },

            ];

            subAccounthtml = (
                <Aux>
                    {(this.props.isSummary) ?
                        <section className='section section--youraccount section--padding--top--40 flex'>
                            <h2 className={titleClass + ' headline--margin--0'}>
                                {title}
                            </h2>
                            <div className='section__action flex-grow-0 ml-auto d-flex'>
                                <Link to='/accounts' className='btn btn--outline mr-2'>{this.props.t('dashboard.subaccounts.see_all_btn')}</Link>
								{this.state.allSubAccounts.filter(s=>s.subAccountDisplayMode.code === "L").length !== 0 && <Link to='/tanks'
									   className='btn btn--outline'>{this.props.t('header.navigation.tanks')}</Link>}
                            </div>
                        </section>
                        :
                        <section className='section section--youraccount section--padding--top--20 flex section--youraccount--notdash'>
                            <div className="flex align-items-center row section--padding--bottom--20 filters">
                                <div className="col-lg-7 filters__left">
                                    <strong>{t('misc.filter')}&nbsp;&nbsp;</strong>
                                    { /* Got disabled after internal discussion and technical issues
                                    <SelectWrapper>
                                        <select onChange={(e) => {
                                                    let selectValue = e.target.value;
                                                    this.onFilterChange(selectValue,'productType');
                                                }}
                                                value={this.state.filters.productType}>
                                            <option value="">Type de produit</option>
                                            { (Array.isArray(this.state.productTypes) && this.state.productTypes.length )
                                                && this.state.productTypes.map(type => {
                                                    if(type.code){
                                                        return (<option value={type.code} key={type.code}>{type.name}</option>);
                                                    } else {
                                                        return '';
                                                    }
                                                })
                                            }
                                        </select>
                                    </SelectWrapper>
                                    */}

                                    <SelectWrapper>
                                        <select id="account-filters" onChange={(e) => {
                                            let selectValue = e.target.value;
                                            this.onFilterChange(selectValue, 'accountType');
                                        }}
                                                value={this.state.filters.accountType}>
                                            <option value="">{t('misc.account_type')}</option>
                                            {this.state.accountTypes.map(type => {
                                                if (type.code) {
                                                    return (<option value={type.code}
                                                                    key={type.code}>{this.props.t('misc.account_types.' + type.code)}</option>);
                                                } else {
                                                    return '';
                                                }
                                            })}
                                        </select>
                                    </SelectWrapper>
                                </div>
                                <div className="col-lg-5 filters__right">
                                    <Sorter
                                        sortOptions={[
                                            {
                                                label: t('profile.account_code'),
                                                id: 'subAccountCode',
                                                value: 'subAccountCode',
                                                type: 'int'
                                            }, {
                                                label: t('profile.account_name'),
                                                id: 'subAccountName',
                                                value: 'subAccountName',
                                                type: 'string'
                                            }, {
                                                label: t('profile.account_type'),
                                                id: 'subAccountType',
                                                value: (this.props.i18n.language === 'fr') ? 'subAccountType.descriptionFr' : 'subAccountType.descriptionEn',
                                                type: 'string'
                                            }, {
                                                label: t('profile.account_balance'),
                                                id: 'totalBalance',
                                                value: 'totalBalance.value',
                                                type: 'float'
                                            }
                                        ]}
                                        items={(subAccountRender && subAccountRender.length) ? subAccountRender : allSubAccounts}
                                        getSortedItems={this.storeSortedItems}
                                        setSortByCallback={this.setSorterCallback}
                                        sortDirection={this.state.sortDirection}
                                        sortField={this.state.sortField}
                                        currentDisplayMode={this.props.currentDisplayMode}
                                    />
                                    <DisplaySwitcher currentDisplayMode={displayMode}
                                                     setDisplayMode={this.setDisplayMode}/>
                                </div>
                            </div>
                            <h2 className={titleClass + ' headline--margin--0'}>
                                {title}
                            </h2>
                        </section>
                    }

                    <section className='section section--accountlist section--padding--bottom--40'>
                        <div className='cards__actions section--padding--bottom--0 section--padding--top--4 flex-column flex-sm-row mt-3'>
                            <button
                                className={(this.state.filters.recentlyViewed) ? 'btn btn--raised btn--rounded btn--fav' : 'btn btn--raised btn--raised--white btn--rounded btn--fav'}
                                onClick={(e) => {
                                    e.preventDefault();
                                    this.onFilterChange(!this.state.filters.recentlyViewed, 'recentlyViewed')
                                }}>
                                {t("profile.recently_consulted")}&nbsp;&nbsp;<span
                                className="qty">({totalRecentlyViewed.length})</span>
                            </button>
                            <button
                                className={(this.state.filters.favorites) ? 'btn btn--raised btn--rounded btn--fav' : 'btn btn--raised btn--raised--white btn--rounded btn--fav'}
                                onClick={(e) => {
                                    e.preventDefault();
                                    this.onFilterChange(!this.state.filters.favorites, 'favorites')
                                }}>
                                <i className="fas fa-star"></i>&nbsp;&nbsp;{t("profile.favorites")} <span
                                className="qty">({totalFavorites.length})</span>
                            </button>
							<SearchForm data={allSubAccounts} updateData={this.onSearchDataUpdate}/>
                        </div>

						<br/>
                        {
                            (displayMode === 'card' || this.props.isSummary)
                                ? (<Aux>
                                    <div className='cards'>
                                        {accounts}
                                    </div>
                                    <Pagination totalRecords={totalCurrentItems} pageLimit={pagination.itemsPerPage}
                                                pageNeighbours={1} onPageChanged={this.onPageChanged}/>
                                </Aux>)
                                : ''
                        }
                        {
                            (displayMode === 'list' && !this.props.isSummary && (subAccountRender || allSubAccounts))
                                ? (<TableContainer
                                    columns={columns}
                                    data={subAccountRender}
                                    onSort={this.handleSort}
                                    initialStateField={this.state.sortField}
                                    initialStateDirection={this.state.sortDirection}/>)
                                : ''
                        }
                    </section>
                </Aux>
            );
        } else {
            subAccounthtml = (
                <section className='section section--youraccount section--padding--40'>
                    <h2 className={titleClass + ' headline--margin--15'}>
                        <Spinner/>
                    </h2>
                </section>
            )
        }

        return (
            <Aux>
                {subAccounthtml}
            </Aux>
        );
    }
}

export default withTranslation()(AccountsList);
